import { Box, Container, Grid, Typography } from "@mui/material"
import BrandCard from "../components/brand-card"
import { useEffect, useState } from "react"
import { createApiCall } from "../api/api-service"

const BrandPage = (props) => {
    const [brandList,setBrandList] = useState()
    const [brandListLength,setBrandListLength] = useState()
    const fetchBrandData = async () => {
            const data = await createApiCall("GET", "inventory/fetch_brands")
            setBrandList(data)
            setBrandListLength(data.length)
        }
    useEffect(()=>{
        fetchBrandData()
    },[])

    if (brandList === undefined) {
        return <>Loading .....</>
    }
    return (
        <>
            <Container sx={{ padding: '10px' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography variant="h6" >Brands</Typography>
                    <Typography variant="body1" >{brandListLength} Products</Typography>
                </Box>

                <Grid container spacing={1}  alignItems={'center'} justifyContent={'center'}>
                    {
                        brandList.map((item)=>{
                           return ( <Grid item xs={2}><BrandCard cardUrl={item?.brand_name} cardText={item?.brand_name} cardImage={item?.brand_image}/></Grid>)
                        })
                    }
                  
                </Grid>
            </Container>
        </>
    )
}

export default BrandPage